import { ArrowLeft, Clock3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function DeferredStudioFeature({
  title,
  description,
  onBack,
  backLabel = 'Back to Studio',
}: {
  title: string;
  description: string;
  onBack: () => void;
  backLabel?: string;
}) {
  return (
    <div className="flex min-h-full items-center justify-center p-6">
      <Card className="w-full max-w-2xl">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-start gap-3">
            <div className="h-10 w-10 rounded-md border bg-muted/40 flex items-center justify-center shrink-0">
              <Clock3 className="h-5 w-5 text-amber-600" />
            </div>
            <div className="space-y-1">
              <h1 className="text-lg font-semibold">{title}</h1>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {description}
              </p>
            </div>
          </div>
          <Button variant="outline" size="sm" className="gap-1.5" onClick={onBack}>
            <ArrowLeft className="h-3.5 w-3.5" />
            {backLabel}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export const STUDIO_BUNDLES_DEFERRED_MESSAGE =
  'Bundles and Industry Kits are deferred for V1. Existing bundle data is preserved, but tenant browsing, authoring, publishing, installation, and archive actions are disabled until this feature reopens.';

export const STUDIO_OPENAPI_DEFERRED_MESSAGE =
  'OpenAPI tool import is deferred for V1. Use MCP Server tools, Custom HTTP tools, or Database query tools for this release.';
